import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormat } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'
import {
  getadviseState,
  getFlag,
  getState,
} from '../../../models/messageCenter'

export const NotificationCenterColumns = (
  onClick: (text: string, t: any) => void,
  startIndex: number,
  messageFlag = 1
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '消息标题',
      dataIndex: 'title',
      align: 'left',
      width: Dimen.Name,
      render: (_, t) => {
        return t.title ? t.title : '-'
      },
    },
    {
      title: '通知机构',
      dataIndex: 'tenantName',
      align: 'left',
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '创建人',
      dataIndex: 'createName',
      align: 'center',
      render: (_, t) => {
        return t.createName ? t.createName : '-'
      },
    },
    {
      title: '通知发送时间',
      dataIndex: 'effectiveTime',
      align: 'center',
      render: (_, t) => {
        return t.effectiveTime
          ? moment(t.effectiveTime).format(DateTimeFormat)
          : '-'
      },
    },
    {
      title: '通知过期时间',
      dataIndex: 'expirationTime',
      align: 'center',
      render: (_, t) => {
        return t.expirationTime
          ? moment(t.expirationTime).format(DateTimeFormat)
          : '-'
      },
    },
    {
      title: '消息状态',
      dataIndex: 'state',
      align: 'center',
      render: (_, t) => {
        return messageFlag == 1 ? `${t.read} / ${t.sum}` : (getState(t.state) || '-')
      },
    },
    {
      title: '通知状态',
      dataIndex: 'adviseState',
      align: 'center',
      render: (_, t) => {
        return getadviseState(t.adviseState) || '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '6rem',
      render: function Element(_, t) {
        return (
          <>
            {t?.adviseState == 2 ? (
              <Button
                type='primary'
                size='small'
                ghost
                style={{ marginRight: '5px' }}
                onClick={() => {
                  onClick('postpone', t)
                }}
              >
                一键延期
              </Button>
            ) : t?.adviseState == 1 ? (
              <Button
                size='small'
                ghost
                danger
                style={{ marginRight: '5px' }}
                  onClick={() => {
                  onClick('expire', t)
                }}
              >
                一键到期
              </Button>
            ) : (
              ''
            )}

            <Button
              type='primary'
              size='small'
              style={{ marginRight: '5px' }}
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑通知
            </Button>
            <Button
              type='primary'
              size='small'
              danger
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除通知
            </Button>
          </>
        )
      },
    },
  ]
}
